export const getNameFromKey = (key) => {
  const keyParts = key.split("-");
  if (keyParts.length === 3) {
    return (
      keyParts[1] +
      " " +
      { rt: "right", lt: "left" }[keyParts[2]] +
      " " +
      keyParts[0]
    );
  } else if (keyParts.length == 2) {
    return { rt: "right", lt: "left" }[keyParts[1]] + " " + keyParts[0];
  } else {
    return key;
  }
};

export const SORENESS_LEVELS = [
  {color: "#b9e6b9", label: "No Soreness"},
  {color: "#008000", label: "Mild Soreness"},
  {color: "#ffd500", label: "Moderate Soreness"},
  {color: "#ff6b00", label: "Very Sore"},
  {color: "#ff060b", label: "Extremely Sore"},
]

export const PAIN_LEVELS = [
  {color: "#b9e6b9", label: "No Pain"},
  {color: "#008000", label: "Mild Pain"},
  {color: "#ffd500", label: "Moderate Pain"},
  {color: "#ff6b00", label: "Very Painful"},
  {color: "#ff060b", label: "Extremely Painful"},
]
